<template>
  <div id="score-ct"  v-if="show">
    <!-- 老师 -->
      <div id="score" class="score-teacher" v-if="!student_type && !historyStatus">
        <i class="close" @click="close"></i>
        <p class="lamp-title">计分器</p>
        <div class="sore-content">

          <div class="score-item" v-for="(value,index) in initData">
            <span class="score-name">{{value.name}}</span>
            <div class="score-name-modify" v-if="value.inputStatus">
              <!-- v-if="value.inputStatus" -->
              <input type="text" name="modify" maxlength="12" :value="value.inputName" @input="specifiName($event,index)" autocomplete="off" placeholder="请填入小组名称">
              <i class="close-input-i" @click="clearInput(index)"></i>
            </div>
           
            <div class="score-add-reduce">
              <span class="reduce" @click="reduce(index)"></span>
              <span class="font" :style="{color:colorArr[index%6]}">{{value.score}}</span>
              <span class="add" @click="add(index)"></span>
            </div>
            <!-- close_ico_4 -->
            <div class="item-son modf-sure" v-if="value.inputStatus" @click="modfSure(index)">
              <i></i>
            </div>
            <div class="item-son modf-close" v-if="value.inputStatus" @click="modfClose(index)">
              <i></i>
            </div>
            <div class="item-son modf" v-if="!value.inputStatus" @click="modf(index)">
              <i></i>
            </div>
            <div class="item-son detele" @click="remove(index)">
              <i></i>
              <div class="item-son item-add" @click.stop="addItem" v-if="index+1 == initData.length">
                <i></i>
              </div>
            </div>
          </div>

        </div>

        <div class="score-tools">
          <div class="tools-item" @click="tools(1)">
            <i class="tools-1"></i>
            <span>清零</span>
          </div>
          <div class="tools-item" @click="tools(2)">
            <i class="tools-2"></i>
            <span>排序</span>
          </div>
          <div class="tools-item" @click="tools(3)">
            <i class="tools-3"></i>
            <span>全部-1</span>
          </div>
          <div class="tools-item" @click="tools(4)">
            <i class="tools-4"></i>
            <span>全部+1</span>
          </div>
          <div class="tools-item" @click="tools(5)">
            <i class="tools-5"></i>
            <span>历史</span>
          </div>
          <div class="tools-item" @click="tools(6)">
            <i class="tools-6"></i>
            <span>保存</span>
          </div>
        </div>

      </div>

      <div id="score" class="score-history" v-if="!student_type && historyStatus">
        <div class="history-back" @click="hisroryBack">
          <i></i>
          <span>返回</span>
        </div>
        <i class="close" @click="close"></i>
        <p class="lamp-title history">历史记录</p>
        <div class="history-content">

          <div class="history-item" v-for="(value,index) in historyArr">
            <div class="item-top">
              <div class="left">
                <span>{{value.max_score_group_names.join("、")}}<i></i></span>
              </div>
              <div class="right">
                {{value.create_at}}
              </div>
            </div>
            <div class="item-bottom">
              <div class="left">
                <span v-for="(value_son,index_son) in value.score_indicator_groups">{{value_son.name+"："+value_son.score}}{{index_son+1 != value.score_indicator_groups.length?'，':''}}</span>
              </div>
              <div class="right" @click="detailScore(value.id)">
                继续计分
              </div>
            </div>
          </div>

          <div class="score-more" v-if="detailObj.data.pagination.total_pages != Object.keys(datailObjTotal).length" @click="moreHistory">点击加载更多</div>
          <div class="score-more" v-if="detailObj.data.pagination.total_pages == Object.keys(datailObjTotal).length">-- 没有了 --</div>
        </div>
      </div>

      <!-- 学生 -->
      <div id="score" class="score-student" v-if="student_type">
        <!-- <i class="close" @click="close"></i> -->
        <p class="lamp-title">计分器</p>
      </div>
  </div>
  

</template>

<script>
import { getStuBookScreen } from './indexApi'
import {
 isBadWord
} from "@/api/commonApi";
export default {
  name: "score-ct",
  data() {
    return {
      //是否显示信号灯
      show:false,
      //是否为学生类型
      student_type: false,
      //更新组件key
      key:0,
      //result数据
      data:null,
      //随机选择的颜色
      colorArr:['#FA6400','#E02020','#F7B500','#44D7B6','#0091FF','#6236FF'],
      //是否显示历史数据
      historyStatus:false,
      //默认数据
      initData:[],
      //升降序
      sortStatus:true,
      //详情列表
      detailObj:null,
      //详情历史数据(总和)
      datailObjTotal:{},
      historyArr:[],
      //获取数据当前页数
      historyPage:0,
      //是否点击清空按钮
      closeInput:false,
      groupNameArr:[],
      //是否是关闭点击
      is_close_click:false,
      timer:null,
      save_success:1,
      save_fail:2,
      save_no_opera:3
    };
  },
  watch: {
    receData(val){
      console.log(val);
      this.detailEvent(val);
      if(val.data.is_open==1 && !this.has_send_msg){
        this.has_send_msg = true;
        this.$flydata.flydataTrack(251);//计分器埋点
      }
    }
  },
  computed: {
    receData(){
        return this.$store.state.interaction.score_Receive;
    }
  },
  methods: {
    moreHistory(){
       if(this.detailObj.data.pagination.total_pages == this.detailObj.data.pagination.current_page){
        return;
       }
       console.log(this.detailObj.data.pagination.current_pages)
       this.historyPage = parseInt(this.detailObj.data.pagination.current_page) + 1;
       localStorage.setItem("history_page",this.historyPage)
       this.$store.commit('sendscoreevent',this.key+'&event_indicator_get_list');
       this.key++;
    },
    detailScore(id){
      localStorage.setItem("score_detail_id",id);
      this.$store.commit('sendscoreevent',this.key+'&event_indicator_get_detail');
               this.key++;
      this.$flydata.flydataTrack(254);//计分器-历史-继续计分埋点
    },
    hisroryBack(){
       this.$store.commit('sendscoreevent',this.key+'&event_indicator_return');
               this.key++;
    },
    addItem(){
      if(this.judeIsOpera()){
          this.$toast("请先完成当前操作");
          return;
      }
      let name = '';
      for(let i=1;i<100;i++){
        if(!this.groupNameArr.includes("新增小组"+i)){
          name = "新增小组"+i;
          break;
        }
      }
      this.initData.push({
        id:0,
        inputName: name,
        inputStatus: false,
        name: name,
        score: 0
      })
      this.toolsInit();
    },
    remove(index){
      if(this.judeIsOpera()){
          this.$toast("请先完成当前操作");
          return;
      }
      if(this.initData.length == 1){
        this.$toast("至少保留一项");
        return;
      }
      this.initData.splice(index,1);
      this.toolsInit();
    },
    inputBlur(){
      setTimeout(()=>{
        if(this.closeInput){
          this.closeInput = false;
          return;
        }
        for(let value of this.initData){
          if(value.inputName != ''){
            if(!this.groupNameArr.includes(value.inputName)){
              value.name = value.inputName;
            }else{
              if(value.inputStatus){
                this.$toast("名字不能重复");
              }
            }
          }else{
            value.inputName = value.name;
          }
          value.inputStatus = false;
        }
        this.toolsInit();
      },120)
    },
    clearInput(index){
      // this.closeInput = true;
      this.initData[index].inputName = "";
      this.$nextTick(()=>{
            console.log($("input"));
            $("input").focus();
      })
      this.toolsInit();
    },
    specifiName(e,index) {
      var that = this;
      var val = e.target.value;
      this.initData[index].inputName = val;
      console.log(val);
    },
    checkSentive(name){
      return new Promise((resolve, reject) => {
        let data = {
          "word": name
        }
         isBadWord(data)
          .then((res) => {
            if (res.errCode == 0) {
              resolve(res.data.status)
            } else {
              this.$message(res.msg);
            }
          })
          .catch((err) => {
            throw new Error(err);
          });  
      })
    },
    async modfSure(index){
      let receName = this.initData[index].inputName;
      if(receName == ""){
        this.$toast("小组名称不能为空");
        return;
      }
      let result = await this.checkSentive(receName);
      if(result){
        this.$message.error("存在敏感词汇");
        return;
      }
      if(!this.groupNameArr.includes(receName)){
          this.initData[index].name = receName;
          this.initData[index].inputStatus = false;
          this.toolsInit();
      }else{
          if(this.initData[index].name == receName){
            this.modfClose(index);
            return;
          }
          this.$toast("小组名称不能重复");
      }
    },
    modfClose(index){
      this.initData[index].inputStatus = false; 
      this.$forceUpdate();
      this.toolsInit();
    },
    modf(index){
      if(this.judeIsOpera()){
          this.$toast("请先完成当前操作");
          return;
      }
      // setTimeout(()=>{
      //     console.log(index);
      //     this.initData[index].inputStatus = true; 
      //     this.$forceUpdate()
      //     this.$nextTick(()=>{
      //       console.log($("input"));
      //       $("input").focus();
      //     })
      //     this.toolsInit();
      //     console.log(this.initData);
      // },160)
      console.log(index);
      this.initData[index].inputStatus = true; 
      this.$forceUpdate()
      this.$nextTick(()=>{
        console.log($("input"));
        $("input").focus();
      })
      this.toolsInit();
      console.log(this.initData);
    },
    compare(property,desc) {
      return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          if(desc==true){
              // 升序排列
              return value1 - value2;
          }else{
              // 降序排列
              return value2 - value1;
          }
      }
    },
    judeIsOpera(){
        for(let value of this.initData){
          if(value.inputStatus){
            this.$nextTick(()=>{
                  console.log($("input"));
                  $("input").focus();
            })
            return true;
          }
        }
        return false;
    },
    tools(type,status){
       if(this.judeIsOpera() && !status){
          this.$toast("请先完成当前操作");
          return;
       }
       switch(type){
            case 1:
              console.log("11111");
              for(let value of this.initData){
                value.score = 0;
              }
              this.toolsInit();
              this.$flydata.flydataTrack(255);//计分器-清零埋点
              break;
            case 2:
              console.log("22222");
              this.sortStatus = !this.sortStatus;
              this.initData.sort(this.compare("score",this.sortStatus))
              this.$flydata.flydataTrack(258);//计分器-排序埋点
              this.toolsInit();
            break;
            case 3:
              console.log("333333");
              for(let value of this.initData){
                value.score = parseInt(value.score) - 1;
              }
              this.$flydata.flydataTrack(257);//计分器-全部-1埋点
              this.toolsInit();
            break;
            case 4:
              console.log("444444");
              for(let value of this.initData){
                value.score = parseInt(value.score) + 1;
              }
              this.$flydata.flydataTrack(256);//计分器-全部+1埋点
              this.toolsInit();
            break;
            case 5:
              console.log("555555");
               this.datailObjTotal = {};
               this.historyArr = [];
               this.historyPage = 1;
               localStorage.setItem("history_page",this.historyPage)
               this.$store.commit('sendscoreevent',this.key+'&event_indicator_get_list');
               this.key++;
              this.$flydata.flydataTrack(253);//计分器-历史埋点
              break;
            case 6:
              console.log("666666");
              let obj = {
                class_id: this.$cookies.get("class_id"),
                id: this.data.data.id,
                score_indicator_groups: this.initData
              }
              this.$store.commit('sendscoredataevent',obj);
              this.key = Math.random();
              this.$store.commit('sendscoreevent',this.key+'&event_indicator_save');
              // this.key++;
              if(status == 'auto'){
                this.is_close_click = true;
                return;
              }
              this.is_close_click = false;
              this.$flydata.flydataTrack(252);//计分器-保存埋点
              // this.$toast("保存成功");
            break;
            default:
            console.log('信号灯返回结果没有匹配')
            break;
        }
    },
    toolsInit(){
      let obj = {
        class_id: this.$cookies.get("class_id"),
        id: this.data.data.id,
        score_indicator_groups: this.initData
      }
      this.$store.commit('sendscoreevent',this.key+'&event_indicator_update');
      this.key++;
      this.$store.commit('sendscoredataevent',obj);
    },
    reduce(index){
      if(this.judeIsOpera()){
          this.$toast("请先完成当前操作");
          return;
      }
      this.initData[index].score = parseInt(this.initData[index].score) - 1;
      this.toolsInit();
    },
    add(index){
      if(this.judeIsOpera()){
          this.$toast("请先完成当前操作");
          return;
      }
      this.initData[index].score = parseInt(this.initData[index].score) + 1;
      this.toolsInit();
    },
  	close(){
      this.has_send_msg = false;
      this.tools(6,"auto");
      this.timer = setTimeout(()=>{
          this.show = false;
      },1000);
  	},
    detailEvent(val){
        if(val.data.teacher_id && this.$cookies.get("user_type") == this.identity.teacher){
            if(this.$cookies.get("user_id") != val.data.teacher_id){
              console.log("不是该老师操作");
                return;
            }
        }
        if(val.data.is_open == 0){
          this.show = false;
          return;
        }
        if(!val.data.hasOwnProperty("id")){
          for(let i=1; i <= val.data.pagination.total_pages; i++){
            if(!this.datailObjTotal[i] && val.data.pagination.current_page == i){
              this.datailObjTotal[i] = val.data.list;
            }
          }
          this.historyArr = [];
          for(let value in this.datailObjTotal){
            for(let value_son of this.datailObjTotal[value]){
              this.historyArr.push(value_son)
            }
          }
          // console.log(this.datailObjTotal);
          // console.log(this.historyArr);
          this.detailObj = val;
          this.historyStatus = true;
          console.log("我是历史数据");
          return;
        }
        this.init(val);
        if(this.student_type){
          this.show = false;
          return;
        }
        //1:开启 0:结束 2：初始化 3：关闭 4：未点击
        switch(val.data.is_open){
            case 0:
              this.show = false;
              console.log("00000");
            break;
            case 1:
              this.show = true;
              this.groupNameArr = [];
              for(let [index,value] of (val.data.score_indicator_groups).entries()){
                if(this.initData.length > 0){
                  if(this.initData[index]){
                     value['inputStatus'] = !this.initData[index].inputStatus ? false : true;
                     if(value['inputStatus']){
                         value['inputName'] = this.initData[index].inputName  ? this.initData[index].inputName : this.initData[index].inputName == "" ? "" :value.name;;
                      }else{
                          value['inputName'] = value.name;
                      }
                    
                  }
                    //  value['inputStatus'] = value.inputStatus ? value.inputStatus : false;
                    // value['inputName'] = value.inputName  ? value.inputName : value.inputName == "" ? "" :value.name;
                }
                this.groupNameArr.push(value.name);
              }
              this.initData = val.data.score_indicator_groups;
              console.log("yesyesyesyesyesyes");
              console.log(this.initData);
              this.historyStatus = val.data.is_click_history;
              if(this.historyStatus){
                this.$store.commit('sendscoreevent',this.key+'&event_indicator_get_list');
                this.key++;
              }
              //is_save_status 0初始化  1成功 2失败 3无任何操作保存
              if(val.data.is_save_status == this.save_success){
                  this.$toast("保存成功");
              }else if (val.data.is_save_status == this.save_fail){
                  this.$toast("保存失败");
              }else if (val.data.is_save_status == this.save_no_opera){
                  if(!this.is_close_click){
                    this.$toast("请先操作,再进行保存");
                  }
              }else{
                console.log("正常修改");
              }
              if(this.is_close_click){
                  this.show = false;
                  this.$store.commit('sendscoreevent',this.key+'&event_indicator_close');
                  this.key++;
                  clearTimeout(this.timer);
                  Object.assign(this.$data, this.$options.data());
                  return;
              }
              console.log("11111");
            break;
            case 2:
              console.log("22222");
            break;
            case 3:
              console.log("333333");
            break;
            case 4:
              console.log("444444");
            break;
            default:
            console.log('信号灯返回结果没有匹配')
            break;
        }
    },
    init(val){
      this.student_type = this.identity.student == this.$cookies.get("user_type") ? true : false
      if(this.key > 10){
         this.key = 0;
      }
      this.data = val;
    }
  },
  created() {},
  components: {},
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
    #score-ct {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1999;
      width: 100%;
      height: 100%;
      overflow: auto;
      background: rgba($color: #000000, $alpha: 0.2);
      // .score-student {
      //    width: 4rem;
      //    height:3.12rem;
      //    padding-left: 0.16rem;
      //    .lamp-title {
      //     margin-top: 0.16rem;
      //     font-size: 0.16rem;
      //    }
       
      //    }
      }
      .score-history {
         .lamp-title {
            text-align: center;
            padding-left: 0 !important;
          }
          .history-back {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0.22rem;
            left: 0.24rem;
            margin-top: 0.03rem;
            cursor: pointer;
            i {
              display: inline-block;
              width: 0.2rem;
              height: 0.2rem;
              margin-right: 0.02rem;
              background: url("../../assets/images/Index／Arrowldown／default.svg") no-repeat center center;
            }
            span {
              font-size: 0.18rem;
              font-weight: bold;
              color: #037BFE;
            }
          }
          .score-more {
            text-align: center;
            color: #475669;
            margin-top: 0.16rem;
            font-size: 0.16rem;
            cursor: pointer;
          }
          .history-content {
              width: 100%;
              margin-top: 0.16rem;
              height: calc(100% - 1rem);
              padding: 0 0.4rem 0 0.3rem;
              overflow: auto;
            .history-item {
              width: 100%;
              min-height: 0.9rem;
              padding: 0.16rem;
              background: #F3F6F9;
              border-radius: 0.03rem;
              margin-bottom: 0.16rem;
              .item-top {
                display: flex;
                // align-items: center;
                flex-flow: row nowrap;
                justify-content: space-between;
                overflow: hidden;
                  .left {
                    display: flex;
                    align-items: center;
                    width: calc(100% - 1.6rem);
                      float: left;
                      font-size: 0.16rem;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.87);
                      i {
                        display: inline-block;
                        width: 0.24rem;
                        height: 0.24rem;
                        margin-left: 0.02rem;
                        vertical-align: sub;
                        background: url("../../assets/images/medal_1.svg") no-repeat center center;
                        background-size: 100% 100%;
                      }
                  }
                  .right {
                      margin-top: 0.02rem;
                      font-size: 0.16rem;
                      color: rgba(0, 0, 0, 0.87);
                      float: right;
                  }
              }
              .item-bottom {
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                overflow: hidden;
                margin-top: 0.14rem;
                  .left {
                    width: calc(100% - 1rem);
                      float: left;
                      font-size: 0.16rem;
                      color: rgba(0, 0, 0, 0.87);
                  }
                  .right {
                      float: right;
                      font-size: 0.16rem;
                      font-weight: bold;
                      cursor: pointer;
                      color: #037BFE;
                  }
              }
            }
          }
      }
    #score {
      position: absolute;
      left:50%;
      top:50%; 
      transform: translateX(-50%) translateY(-50%);
      width: 8.46rem;
      height:5.78rem;
      // padding-left: 0.3rem;
      z-index: 1999;
      background: #fff;
      .close {
      	position: absolute;
      	top: 0;
      	right: 0;
      	cursor: pointer;
      	display: inline-block;
      	width: 0.5rem;
      	height: 0.5rem;
      	background: url("../../assets/images/close_ico_2.svg") no-repeat center center;
      }
      .lamp-title {
        font-weight: bold;
        font-size: 0.18rem;
        padding-left: 0.3rem;
        color: #202020;
      	margin-top: 0.3rem;
      }
      .sore-content {
        width: 100%;
        height: calc(100% - 1.5rem);
        overflow: auto;
        margin-top: 0.24rem;
        margin-bottom: 0.35rem;
        .score-item {
          position: relative;
          display: flex;
          text-align: right;
          // justify-content: center;
          padding-left: 0.24rem;
          align-items: center;
          width: 100%;
          height: 0.48rem;
          margin-bottom: 0.24rem;
        }
        .score-item:last-child {
           margin-bottom: 0;
        }
        .score-name {
          display: inline-block;
          width: 2.2rem;
          font-size: 0.16rem;
          font-weight: bold;
          margin-right: 0.32rem;
          overflow: hidden;
          white-space: normal;
          text-overflow: ellipsis;
          color: rgba(0, 0, 0, 0.85);
        }
        .score-name-modify {
          position: absolute;
          left: 0.24rem;
          display: flex;
          align-items: center;
          width: 2.34rem;
          height: 0.48rem;
          background: #FFFFFF;
          border-radius: 0.04rem;
          border: 0.01rem solid #027BFE;
          input {
            width: 2.05rem;
            font-size: 0.16rem;
            font-weight: bold;
            padding-left: 0.12rem;
            color: rgba(0, 0, 0, 0.85);
          }
          i {
            display: inline-block;
            width: 0.2rem;
            height: 0.2rem;
            cursor: pointer;
            background: url("../../assets/images/close_ico_5 (1).svg") no-repeat center center;
          }
        }
        // .close-input-i {
        //   position: absolute;
        //   left: 2.32rem;
        //   display: inline-block;
        //   width: 0.2rem;
        //   height: 0.2rem;
        //   cursor: pointer;
        //   background: url("../../assets/images/close_ico_5 (1).svg") no-repeat center center;
        // }
        .score-add-reduce {
          background: #FFFFFF;
          border-radius: 0.04rem;
          border: 0.01rem solid #DCDFE6;
          height: 0.48rem;
          overflow: hidden;
          span {
            float: left;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
          .reduce {
            width: 0.48rem;
            height:100%; 
            cursor: pointer;
            background: #EFF3F6 url("../../assets/images/icon_minus_default .svg") no-repeat center center;
          }
          .font {
            width: 1.44rem;
            height:100%; 
            font-size: 0.3rem;
            font-weight: 600;
          }
          .add {
            width: 0.48rem;
            height:100%; 
            cursor: pointer;       
            background: #EFF3F6 url("../../assets/images/icon_close_default (1).svg") no-repeat center center;
          }
        }
        .item-son {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 0.32rem;
              height: 0.32rem;
              background: #cee5ff;
              border-radius: 0.16rem;
              cursor: pointer;
              i {
                  display: inline-block;
                  width: 0.14rem;
                  height: 0.14rem;
              }
        }
        .modf {
          margin: 0 0.36rem 0 0.32rem;
          i{
           
            background: url("../../assets/images/icon_edit_default.svg") no-repeat center center;
          }
        }
        .modf-sure {
          background:rgba(82, 196, 27, 0.19);
          margin: 0 0.36rem 0 0.32rem;
          i{
           
            background: url("../../assets/images/cross_ico_sure_4.svg") no-repeat center center;
          }
        }
        .modf-close {
          background:rgba(245, 34, 45, 0.19);
          margin-right: 0.36rem;
          i{
           
            background: url("../../assets/images/close_ico_4.svg") no-repeat center center;
          }
        }
        .detele {
          position: relative;
          i {
            background: url("../../assets/images/Index／Delete default.svg") no-repeat center center;
          }
        }
        .item-add {
          position:absolute;
          right: -0.7rem;
          opacity: 1;
          i {
            background: url("../../assets/images/icon_close_default (2).svg") no-repeat center center;
          }
        }
      }
      .score-tools {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 0.64rem; 
        background: #F3F6F9;
        .tools-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          width: 0.8rem;
          height: 0.48rem;
          box-shadow: 0.01rem 0rem 0rem 0rem rgba(0, 0, 0, 0.1);
          i {
            display: inline-block;
            width: 0.24rem;
            height: 0.24rem;
          }
          span {
            font-size: 0.16rem;
            color: #475669;
          }
          .tools-1 {
            background: url("../../assets/images/reset_ico.svg") no-repeat center center;
          }
          .tools-2 {
            background: url("../../assets/images/sort_ico.svg") no-repeat center center;
          }
          .tools-3 {
            background: url("../../assets/images/reduce_ico.svg") no-repeat center center;
          }
          .tools-4 {
            background: url("../../assets/images/add_ico_4.svg") no-repeat center center;
          }
          .tools-5 {
            background: url("../../assets/images/history_ico.svg") no-repeat center center;
          }
          .tools-6 {
            background: url("../../assets/images/save_ico.svg") no-repeat center center;
          }
        }
      }
    }
    @media screen and (max-width:846px) {
      .score-teacher {
        width: 5.46rem !important;
        .lamp-tools {
          margin-bottom: 0.24rem !important;
        }
      }
    } 
    @media screen and (max-height:560px) {
      #score {
        height: 4rem;
      }
    } 
</style>
